import { ARTA_EDITIONS, ARTA_FEATURES, ArtaEdition, ArtaFeature } from './edition';

export type ArtaReleaseMetadata = {
  schemaVersion: 1;
  product: 'arta';
  version: string;
  supportedEditions: ArtaEdition[];
  features: ArtaFeature[];
  compatibility: {
    node: string;
    backstage: string;
    catalogSchema: number;
    configSchema: number;
    upgradeFrom: string[];
  };
};

const SEMVER = /^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?$/;

export function validateReleaseMetadata(value: unknown): ArtaReleaseMetadata {
  if (!value || typeof value !== 'object') throw new Error('Release metadata must be an object.');
  const metadata = value as ArtaReleaseMetadata;
  if (metadata.schemaVersion !== 1 || metadata.product !== 'arta') {
    throw new Error('Unsupported ARTA release metadata schema.');
  }
  if (!SEMVER.test(metadata.version)) throw new Error(`Invalid ARTA release version "${metadata.version}".`);
  if (!Array.isArray(metadata.supportedEditions) || metadata.supportedEditions.length === 0 ||
      metadata.supportedEditions.some(item => !ARTA_EDITIONS.includes(item))) {
    throw new Error('Release metadata contains invalid supported editions.');
  }
  if (!Array.isArray(metadata.features) || metadata.features.some(item => !ARTA_FEATURES.includes(item))) {
    throw new Error('Release metadata contains invalid features.');
  }
  if (!metadata.compatibility || metadata.compatibility.catalogSchema < 1 || metadata.compatibility.configSchema < 1) {
    throw new Error('Release metadata compatibility schema versions must be positive.');
  }
  if (!Array.isArray(metadata.compatibility.upgradeFrom) ||
      metadata.compatibility.upgradeFrom.some(version => !SEMVER.test(version))) {
    throw new Error('Release metadata contains an invalid upgradeFrom version.');
  }
  return metadata;
}

export function assertUpgradeSupported(fromVersion: string, target: ArtaReleaseMetadata): void {
  if (fromVersion === target.version) return;
  if (!target.compatibility.upgradeFrom.includes(fromVersion)) {
    throw new Error(`Upgrade from ARTA ${fromVersion} to ${target.version} is not supported.`);
  }
}
